import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { utility } from '../../common/utility';
import { environment } from '../../../environments/environment';
import { AccountService } from 'src/app/services/AccountService';
import { MessageService } from 'src/app/services/MessageService';

import { AlertService } from 'src/app/services/AlertService';

@Component({
  selector: 'app-message-detail',
  templateUrl: './message-detail.component.html',
  styleUrls: ['./message-detail.component.scss']
})
export class MessageDetailComponent implements OnInit {

    message: any;
    vCardUrl: any;
    canDeleteMessage: boolean = false;


    constructor(private activatedRoute: ActivatedRoute,
        private router: Router,
        private breadcrumbService: AppBreadcrumbService, private accountService: AccountService,
        private messageService: MessageService,      
        private alertService: AlertService) { }

    ngOnInit(): void {
        this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
            this.message = this.activatedRoute.snapshot.data['message'];
            this.vCardUrl = 'data:text/x-vcard;charset=utf-8,' + encodeURIComponent(this.message.VCard);
            this.breadcrumbService.setItems([
                this.breadcrumbService.messageBoard,
                { label: 'Message #' + this.message.Id, routerLink: [] }
            ]);
        });  
        this.canDeleteMessage = this.accountService.CanDeleteMessage(this.message.PostingUserID);   
    }
    getLocation() {
        var result = '';

        if (this.message.StatesName != null && this.message.CountriesName != null) {
            result = this.message.StatesName + ', ' + this.message.CountriesName;
        } else if (this.message.StatesName != null) {
            result = this.message.StatesName
        } else if (this.message.CountriesName != null) {
            result = this.message.CountriesName;
        }

        return result;
    }
    formatPhoneNumber(number) {
        return utility.formatPhoneNumber(number);
    }

    NavMailto() {

        if(this.message.AdminEmail != null){
            window.location.href = "mailto:" + this.message.ContactEmail + "?cc=" + this.message.AdminEmail + "&subject=" + this.message.HeadLine;
        }
        else{
            window.location.href = "mailto:" + this.message.ContactEmail + "&subject=" + this.message.HeadLine;

        }
        
    }

    getDocumentUrl(doc: any): string {
        var result = environment.imageBase.concat('/', doc.DocumentURI);
        return result;
    }

    OpenUrl(doc: any) {
        var url = this.getDocumentUrl(doc);
        utility.OpenURl(url);
   
    }

    downloadVCard() {
        document.location.href = this.vCardUrl;
    }

    removeMessage() {
        this.messageService.RemoveMessage(this.message.Id).subscribe(
          result => {
            this.router.navigate(['/message/view']);
    
          },
          error => {
            this.alertService.SetMessage('error', 'There is an error while deleting message');
          }
        )
      }
      
}
